import { filterPage } from "components/common/Filters/FiltersHelper";
import React from "react";
import { ABOVE_PROPERTY } from "utils/CommonConstants";
import { routes } from "utils/routes";
import { Comments } from "../Comments";
import TemplatePlanProgressList from "../PlanProgress";
import Sections from "../Sections/List";

const CommentsTab = React.memo(({ planId }: { planId?: string }) => {
  if (!planId) return null;
  return <Comments planId={planId} />;
});

const PlanProgressTab = React.memo(() => {
  return <TemplatePlanProgressList />;
});

export const getTabDetails = (selectedMyPlanDetail: any, planType: string, isViewMode?: boolean) => {
  const isTemplatePlan = selectedMyPlanDetail.innCode === ABOVE_PROPERTY;
  const url = window.location.href?.toLocaleLowerCase();
  const isInncodePlanDetails = url.includes(routes.TemplatePlanDetail);
  let common: any = [
    {
      label: "Action Plan",
      content: () => <Sections selectedPlanDetail={selectedMyPlanDetail} planType={planType} />,
      filtersToClear: [filterPage.planProgressFromLibraryDisplay, filterPage.libraryPlanDetailsDisplay]
    }
  ];
  if (isInncodePlanDetails) {
    common.push({
      label: "Plan Progress",
      content: PlanProgressTab,
      filtersToClear: []
    });
  }

  return isTemplatePlan || isViewMode
    ? common
    : [
        ...common,
        {
          label: "Comments",
          content: () => <CommentsTab planId={selectedMyPlanDetail?.id} />
        }
      ];
};
